__webpack_require__.p = "https://uat.pos.byonde.asia/";